import { render } from "./InstallWizardGroupCreation.vue?vue&type=template&id=026c0307"
import script from "./InstallWizardGroupCreation.vue?vue&type=script&lang=js"
export * from "./InstallWizardGroupCreation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__